import { format } from 'date-fns'
import { formatInTimeZone } from 'date-fns-tz'

// Localized short date. Locale-driven via date-fns' default locale (set from
// the active i18next language in src/i18n/date-locale). en -> "02/20/2026",
// fr -> "20/02/2026".
export const formatDateOnly = (
  date: Date | number | string | null | undefined,
  timezone?: string,
): string => {
  if (!date) return '-'
  if (timezone) return formatInTimeZone(new Date(date), timezone, 'P')
  return format(date, 'P')
}
